import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { EventTypes } from '../../../constants/event';
import {
  IMessageReceived,
  messagingActions,
} from '../../../reducers/messagingSlice';
import { SLICE_NAME } from './unresolvedItems.constants';
import { IUnresolvedItemsState } from './unresolvedItems.props';

const initialState: IUnresolvedItemsState = {
  allDismissed: false,
};

export const unresolvedItemsSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    resetUnresolvedItems: () => {
      return initialState;
    },
    dismissAllUnresolvedItems: (state) => {
      state.allDismissed = true;
    },
  },
  extraReducers: (builder) => {
    // Reset at the start of a new session so stale dismissals don't bleed
    // across sessions. The cumulative lists themselves live on the hypothesis
    // frame and shrink/clear when the producer resets them.
    builder.addCase(
      messagingActions.messageReceived,
      (state, action: PayloadAction<IMessageReceived>) => {
        const isNewSession = action.payload.messages.some(
          (message) =>
            message.event === EventTypes.startSession ||
            message.event === EventTypes.carEnter
        );
        if (isNewSession) {
          return initialState;
        }
      }
    );
  },
});

const { resetUnresolvedItems, dismissAllUnresolvedItems } =
  unresolvedItemsSlice.actions;

export { initialState, resetUnresolvedItems, dismissAllUnresolvedItems };
export default unresolvedItemsSlice.reducer;
